'use strict';
var globalThis = require('../internals/global-this');

module.exports = globalThis.Promise;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/promise-native-constructor.js
// module id = 143
// module chunks = 113